/**
 * JANIMONY.CHAT - AUTH SERVICE
 * Authentication utilities
 */

const AuthService = {
  // Get current user
  // NOTE: sessionStorage (not localStorage) — cleared automatically when
  // the tab/browser is closed, so login is never cached across sessions.
  getCurrentUser: () => {
    const userStr = sessionStorage.getItem('janimony_business_user');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Get token
  getToken: () => {
    return sessionStorage.getItem('janimony_business_token');
  },

  // Set user
  setUser: (user, token) => {
    sessionStorage.setItem('janimony_business_user', JSON.stringify(user));
    sessionStorage.setItem('janimony_business_token', token);
    // Clean up any stale localStorage tokens from before this change
    localStorage.removeItem('janimony_business_user');
    localStorage.removeItem('janimony_business_token');
  },

  // Logout
  logout: () => {
    sessionStorage.removeItem('janimony_business_user');
    sessionStorage.removeItem('janimony_business_token');
  },

  // Check if logged in
  isAuthenticated: () => {
    return !!(AuthService.getCurrentUser() && AuthService.getToken());
  }
};

export default AuthService;